import type { FinancialPlanning } from '@/modules/FinancialPlanning/interface/FinancialPlanning';
import type { RegisterFormType } from '@/modules/FinancialPlanning/interface/RegisterForm';
import { useMutation } from '@tanstack/react-query';
import { setupApiClient } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useSendAddFinancialPlanner = () => {
  return useMutation({
    mutationFn: sendAddFinancialPlanner,
  });
};

const sendAddFinancialPlanner = async (body: Body) => {
  const api = setupApiClient({}, true);
  const { data } = await api.post(
    apiConfig.routes.financialPlanning.planners,
    body
  );
  return data;
};

type Body = Omit<Partial<RegisterFormType>, 'hasDependents'> &
  Pick<FinancialPlanning, 'name'>;
